import importerReducers from 'src/modules/shared/importer/importerReducers';
import actions from 'src/modules/formTemplate/importer/formTemplateImporterActions';

export default importerReducers(actions);
